import React from 'react';
import classNames from 'classnames';
// import EllipsisTooltip from '../../Tooltip/EllipsisTooltip';

export default function NotEditableItem({ title, value }) {

  return (
    <div className="info-item">
      <div className="info-item-name">
        {title}
      </div>
      <div className={classNames('info-item-value', { 'info-item-value-empty': !value })}>
        {/*<EllipsisTooltip title={value}>*/}
        {value || '<no data>'}
        {/*</EllipsisTooltip>*/}
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/BaseForm/components/NotEditableItem.js